import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { TerminalImportLogEntity } from "../../types/TerminalImportLogEntity";
import { TerminalImportLogDtoToEntity } from "../mappers/TerminalImportLogDtoToEntity";

const TerminalImportLogApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        TerminalImportLogLoad: builder.query<TerminalImportLogEntity, FormQuery>({
            providesTags: [ResourceName.TERMINAL_IMPORT_LOG],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_IMPORT_LOG}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return TerminalImportLogDtoToEntity(response);
            },
        }),
    }),
});

export const { useTerminalImportLogLoadQuery } = TerminalImportLogApi;
